var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"type":"pie","options":_vm.chartOptions,"series":_vm.series,"width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }